import { ROUTES } from "@nf/constants";
import { SignInButton } from "./SignInButton";
import React from "react";
import { useTranslation } from "next-i18next";

export const LogInButtonMobile = () => {
  const { t } = useTranslation("translations");
  return <SignInButton label={t("web_login_button", "")} url={ROUTES.LOGIN} />;
};
